import React from "react";
import "./Vission_Mission_Component.css";
import parse from "html-react-parser"
import { IDS } from "../../../utils/IDS";

const Vission_Mission_Component = ({ visionData, missionData }) => {
  return (
    <section className="Vission_Mission_Component">
      <div className="container">
        <div className="vission_div">
          <div className="type_holder">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="text_holder">
                  <div>

                  <div className="title_div">
                    <p className="title_text">{visionData?.name || " "}</p>
                  </div>

                  <div className="descn_div">
                    <p className="descn_text">{parse(visionData?.description || " ")}</p>

                    {/* <p className="descn_text">
                      This vision emphasizes a holistic approach to well-being,
                      encompassing physical, mental, emotional, socio-economic,
                      and spiritual aspects.
                    </p>

                    <p className="descn_text">
                      They dream of seeing everyone healthy in a holistic manner
                      & propagating ancient yet scientific wisdom to bring hope
                      to all.
                    </p> */}
                  </div>
                  </div>
                  {/* <div className="descn_div">
                    <p className="descn_text">
                      The core vision of Om Tapovan Ashram is to connect with
                      divine consciousness by coordinating Spirituality,
                      Science, and Pran (life force energy) to make the entire
                      world Gyanmay (full of knowledge), Dhyanmay (full of
                      meditation), & Pranmay (full of life force).{" "}
                    </p>

                    <p className="descn_text">
                      This vision emphasizes a holistic approach to well-being,
                      encompassing physical, mental, emotional, socio-economic,
                      and spiritual aspects.
                    </p>

                    <p className="descn_text">
                      They dream of seeing everyone healthy in a holistic manner
                      & propagating ancient yet scientific wisdom to bring hope
                      to all.
                    </p>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-6 col-sm-6">
                <div className="big_img_holder">
                  <img
                    src={IDS.IMG_URL + visionData?.Our_Vission?.image}
                    // src="/assets/images/vission_mission/vission_mission/img1.png"
                    className="big_img"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="type_holder type_holder_2">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-sm-6 order-lg-2 order-md-1 order-2">
                <div className="big_img_holder">
                  <img
                    src={IDS.IMG_URL + missionData?.Our_Mission?.image}
                    // src="/assets/images/vission_mission/vission_mission/img2.png"
                    className="big_img"
                  />
                </div>
              </div>
              <div className="col-lg-6 order-lg-2">
                <div className="text_holder">
                   <div>

                  <div className="title_div">
                    <p className="title_text">{missionData?.name || " "}</p>
                  </div>

                  <div className="descn_div">
                    <p className="descn_text">{parse(missionData?.description || " ")} </p>

                    {/* <p className="descn_text">
                      This vision emphasizes a holistic approach to well-being,
                      encompassing physical, mental, emotional, socio-economic,
                      and spiritual aspects.
                    </p>

                    <p className="descn_text">
                      They dream of seeing everyone healthy in a holistic manner
                      & propagating ancient yet scientific wisdom to bring hope
                      to all.
                    </p> */}
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vission_Mission_Component;
